import React  from 'react';
import {FieldViewProps} from "../../../../render/view";

export default function FieldTotal_View(props:FieldViewProps) {

    const value = props.field.getViewValue(props.model)

    if (_.isNil(value)) return false

    const icon = _.get(props.field.components, 'ValueIcon', false)

    if (!icon) return <div className="ui5-txt-default">{value}</div>;

    if (icon) {
        return (
            <React.Fragment>
                {icon}
                <div className="ui5-txt-default">{value}</div>
            </React.Fragment>
        )
    }
}
